import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const IntranetLoginPage = Loadable(lazy(() => import('../pages/auth/intranet/LoginPage')));

// DASHBOARD: INTRANET
export const InvoiceListPage = Loadable(lazy(() => import('../pages/intranet/InvoiceListPage')));
export const InvoiceCreate = Loadable(lazy(() => import('../pages/intranet/InvoiceCreatePage')));
export const InvoiceDetailPage = Loadable(
  lazy(() => import('../pages/intranet/InvoiceDetailPage'))
);
export const IntranetDashboardPage = Loadable(
  lazy(() => import('../pages/intranet/DashboardPage'))
);
export const IntranetRequestListPage = Loadable(
  lazy(() => import('../pages/intranet/RequestListPage'))
);

export const IntranetRequestEditPage = Loadable(
  lazy(() => import('../pages/intranet/RequestEditPage'))
);
export const IntranetRequestNewPage = Loadable(
  lazy(() => import('../pages/intranet/RequestNewPage'))
);
export const IntranetRequestViewPage = Loadable(
  lazy(() => import('../pages/intranet/RequestViewPage'))
);
export const FatturazionePage = Loadable(lazy(() => import('../pages/intranet/FatturazionePage')));
export const IntranetUserProfilePage = Loadable(
  lazy(() => import('../pages/intranet/UserProfilePage'))
);
export const IntranetUserListPage = Loadable(lazy(() => import('../pages/intranet/UserListPage')));
export const IntranetUserAccountPage = Loadable(
  lazy(() => import('../pages/intranet/UserAccountPage'))
);
export const IntranetUserCreatePage = Loadable(
  lazy(() => import('../pages/intranet/UserCreatePage'))
);
export const IntranetUserEditPage = Loadable(lazy(() => import('../pages/intranet/UserEditPage')));
export const IntranetMediatorNewPage = Loadable(
  lazy(() => import('../pages/intranet/MediatorCreatePage'))
);
export const IntranetMediatorEditPage = Loadable(
  lazy(() => import('../pages/intranet/MediatorEditPage'))
);
export const IntranetMediatorViewPage = Loadable(
  lazy(() => import('../pages/intranet/MediatorViewPage'))
);
export const IntranetMediatorListPage = Loadable(
  lazy(() => import('../pages/intranet/MediatorListPage'))
);
export const UserProfilePage = Loadable(
  lazy(() => import('../pages/intranet/ClientUserProfilePage'))
);
export const UserListPage = Loadable(lazy(() => import('../pages/intranet/ClientUserListPage')));
export const UserCreatePage = Loadable(
  lazy(() => import('../pages/intranet/ClientUserCreatePage'))
);
export const UserEditPage = Loadable(lazy(() => import('../pages/intranet/ClientUserEditPage')));
export const LanguageListPage = Loadable(lazy(() => import('../pages/intranet/LanguageListPage')));
export const TranslationOrdersPage = Loadable(
  lazy(() => import('../pages/intranet/TranslationOrdersPage'))
);

// MAIN

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));
